<app-non-supported-groups *ngIf="!showContent" [supportedGroups]="['merchants', 'affiliates', 'merchant_groups']"></app-non-supported-groups>
<div class="content" [style.display] = "!showContent ? 'none' : null">
    <div class="view-by-row">
        <div *ngIf="(dashboardApi.currentAccount$ | async).entity_group_name === 'affiliates'"class="flex-child">
            <mat-form-field>
              <mat-label>View</mat-label>
                <mat-select
                    #toolFilter
                    [(value)]="selectedFilter"
                    [panelClass]="'dashboard-select-panel'"
                    (selectionChange)="handleFilterSelectionChange(toolFilter.value)"
                >
                    <mat-option *ngFor="let filter of filters" [value]="filter.value">{{ filter.displayName }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="flex-child display-view">
          <button #viewOptionButton mat-icon-button aria-label="Icon button for display view.">
            <mat-icon [@rotate360]="animateDisplayIcon">{{adToolViewIcon}}</mat-icon>
          </button>
        </div>
    </div>
  <div [style.display]="adToolViewIcon === 'list' ? null : 'none'" class="tools-grid">
    <app-icon-card
      *ngFor="let toolId of filteredTools"
      [config]="tools[toolId]"
      (buttonClick)="onToolButtonClick($event)"
      (favChange)="onFavoriteIconClick$.next({favorite: $event, toolId: toolId})">
    </app-icon-card>
  </div>

  <div [style.display]="adToolViewIcon === 'view_module' ? null : 'none'">
    <table mat-table [dataSource]="filteredToolsDataTableSource" matSort class="mat-elevation-z8" [trackBy]="trackByToolId">
      <ng-container *ngIf="(dashboardApi.currentAccount$ | async).entity_group_name === 'affiliates'" matColumnDef="toggleSwitch">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button (click)="onFavoriteIconClick$.next({favorite: !element.toggleSwitch.state, toolId: element.toolId})">
            <mat-icon class="star-icon" [@visibilityFade]="element.toggleSwitch?.state ? 'visible' : 'hidden'">star</mat-icon>
            <mat-icon class="star-border-icon">star_border</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="buttons">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-raised-button [ngClass]="element.buttons[0]?.buttonClassList" class="first-action" (click)="onToolButtonClick(element.buttons[0].buttonClickResponse)">{{element.buttons[0].buttonText}}</button>&nbsp;
          <button *ngIf="element.buttons[1]?.buttonText" mat-raised-button [ngClass]="element.buttons[1]?.buttonClassList" (click)="onToolButtonClick(element.buttons[1]?.buttonClickResponse)">{{element.buttons[1]?.buttonText}}</button>
        </td>
      </ng-container>

      <ng-container matColumnDef="displayName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ad Tool</th>
        <td mat-cell *matCellDef="let element">
          <img [ngSrc]="element.iconUrl" width="16" height="16"/>{{element.displayName}}
        </td>
      </ng-container>

      <ng-container matColumnDef="displaySubtitle">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element"> {{element.displaySubtitle}} </td>
      </ng-container>

      <ng-container matColumnDef="displayDescription">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Provider</th>
        <td mat-cell *matCellDef="let element"> {{element.displayDescription || 'AvantLink'}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns$ | async"></tr>
      <tr mat-row *matRowDef="let row; columns: (displayedColumns$ | async);"></tr>
    </table>
  </div>
</div>
